import { render, staticRenderFns } from "./MaterialFolderSelectDialog.vue?vue&type=template&id=7f749dd8&scoped=true"
import script from "./MaterialFolderSelectDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialFolderSelectDialog.vue?vue&type=script&lang=ts"
import style0 from "./MaterialFolderSelectDialog.vue?vue&type=style&index=0&id=7f749dd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f749dd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f749dd8')) {
      api.createRecord('7f749dd8', component.options)
    } else {
      api.reload('7f749dd8', component.options)
    }
    module.hot.accept("./MaterialFolderSelectDialog.vue?vue&type=template&id=7f749dd8&scoped=true", function () {
      api.rerender('7f749dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/MaterialFolderSelectDialog.vue"
export default component.exports